import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../_services/auth.service';
@Injectable()
export class AuthStdGuard implements CanActivate {

    constructor(private router: Router, private authService: AuthService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let acc = JSON.parse(localStorage.getItem('currentUser'));
        console.log('test', localStorage)
        // if (acc && acc.guard=='STD'&& !this.authService.isTokenExpired(localStorage.token)) {
        if (acc && acc.Guard == 'STD' && !this.authService.isTokenExpired(localStorage.token)) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/student/auth'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
